import { SharedModule } from '@/app/shared/shared.module';
import { Component, inject, OnInit } from '@angular/core';
import { PhenologicalImagesComponent } from './phenological-images/phenological-images.component';
import { PhenologicalStagesComponent } from './phenological-stages/phenological-stages.component';
import { ExtendedLandViewModel, PlantationService } from '@/app/core/services/plantation.service';
import { GroupedPlantationViewModel } from '@/app/proxy/proxies';

@Component({
  selector: 'app-phenology',
  imports: [SharedModule,
    PhenologicalStagesComponent,
    PhenologicalImagesComponent],
  templateUrl: './phenology.component.html',
  styleUrl: './phenology.component.less'
})
export class PhenologyComponent implements OnInit {
  private _plantationService = inject(PlantationService);
  selectedLand: ExtendedLandViewModel;
  selectedPlantation: GroupedPlantationViewModel;

  ngOnInit(): void {
    this._plantationService.selectedLand$.subscribe((res) => {
      this.selectedLand = res;
    });
    this._plantationService.selectedPlantation$.subscribe((res) => {
      this.selectedPlantation = res;
    });
  }
}
